import React from 'react';
import { Paper, Typography, Box, Container, Grid } from '@mui/material';

const ApplicationReview = () => {
  const applicationSummary = {
    applicantInfo: {
      fullName: "John Doe",
      address: "123 Main St",
      contact: "(555) 123-4567",
      email: "john@example.com"
    },
    policyDates: {
      effectiveDate: "2024-03-20",
      expiryDate: "2025-03-20"
    },
    vehicleInfo: {
      make: "Toyota",
      model: "Camry",
      year: "2022",
      vin: "1HGCM82633A123456"
    },
    driverInfo: {
      licenseNumber: "DL123456",
      experience: "5 years"
    },
    coverage: {
      liability: "$2,000,000",
      collision: "Yes",
      comprehensive: "Yes",
      remarks: [
        "Waiver of Depreciation (OPCF 43) - Declined",
        "Loss of Use Coverage (OPCF 20) - Declined",
        "Liability for Non-Owned Vehicles (OPCF 27) - Declined",
        "First Accident Forgiveness - Not Included"
      ]
    }
  };

  return (
    <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
      <Typography variant="h5" sx={{ mb: 3 }}>
        Application Summary
      </Typography>
      
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" color="primary" sx={{ mb: 1 }}>
              Applicant Information
            </Typography>
            <Box sx={{ pl: 2 }}>
              <Typography>Name: {applicationSummary.applicantInfo.fullName}</Typography>
              <Typography>Address: {applicationSummary.applicantInfo.address}</Typography>
              <Typography>Contact: {applicationSummary.applicantInfo.contact}</Typography>
            </Box>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" color="primary" sx={{ mb: 1 }}>
              Policy Dates
            </Typography>
            <Box sx={{ pl: 2 }}>
              <Typography>Effective Date: {applicationSummary.policyDates.effectiveDate}</Typography>
              <Typography>Expiry Date: {applicationSummary.policyDates.expiryDate}</Typography>
            </Box>
          </Box>
        </Grid>

        <Grid item xs={12} md={6}>
          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" color="primary" sx={{ mb: 1 }}>
              Vehicle Information
            </Typography>
            <Box sx={{ pl: 2 }}>
              <Typography>Make & Model: {applicationSummary.vehicleInfo.make} {applicationSummary.vehicleInfo.model}</Typography>
              <Typography>Year: {applicationSummary.vehicleInfo.year}</Typography>
              <Typography>VIN: {applicationSummary.vehicleInfo.vin}</Typography>
            </Box>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" color="primary" sx={{ mb: 1 }}>
              Coverage Details
            </Typography>
            <Box sx={{ pl: 2 }}>
              <Typography>Liability Limit: {applicationSummary.coverage.liability}</Typography>
              <Typography>Collision Coverage: {applicationSummary.coverage.collision}</Typography>
              <Typography>Comprehensive Coverage: {applicationSummary.coverage.comprehensive}</Typography>
              
              <Typography variant="subtitle1" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>
                Important Remarks:
              </Typography>
              {applicationSummary.coverage.remarks.map((remark, index) => (
                <Typography 
                  key={index} 
                  color="error.main" 
                  sx={{ 
                    fontSize: '0.9rem',
                    mb: 0.5,
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  • {remark}
                </Typography>
              ))}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ApplicationReview; 